import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "../../../common/consts/colors";
export default function ThumbsDown({ color = "offWhite" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.833 12.5H19.1663V2.5H15.833M12.4997 2.5H4.99967C4.30801 2.5 3.71634 2.91667 3.46634 3.51667L0.949674 9.39167C0.874674 9.58333 0.833008 9.78333 0.833008 10V11.6667C0.833008 12.1087 1.0086 12.5326 1.32116 12.8452C1.63372 13.1577 2.05765 13.3333 2.49967 13.3333H7.75801L6.96634 17.1417C6.94968 17.225 6.94134 17.3083 6.94134 17.4C6.94134 17.75 7.08301 18.0583 7.30801 18.2833L8.19134 19.1667L13.6747 13.675C13.983 13.375 14.1663 12.9583 14.1663 12.5V4.16667C14.1663 3.72464 13.9907 3.30072 13.6782 2.98816C13.3656 2.67559 12.9417 2.5 12.4997 2.5Z"
        fill="#14141E"
      />
    </svg>
  );
}
